export class DynamicSmartOffer {
    toneGuidance: string;
    pitchPoints: string[];

    constructor(toneGuidance: string, pitchPoints: string[]) {
        this.toneGuidance = toneGuidance;
        this.pitchPoints = pitchPoints;
    }

    isValid(): boolean {
        return this.toneGuidance.length > 0 && this.pitchPoints.some((p) => p.length > 0);
    }

    equals(other: DynamicSmartOffer): boolean {
        return (
            this.toneGuidance === other.toneGuidance &&
            this.pitchPoints.length === other.pitchPoints.length &&
            this.pitchPoints.every((p, i) => p === other.pitchPoints[i])
        );
    }
}
